import { objComparatorNumber } from "../utils.js";
import axios from 'axios';
import { endpoint, remoteCreate, remoteModifyPut } from "./utils.js";

export function ipsumDevicesRootURL() {
  return endpoint("internal/current/ipsumdevices/");
}

export async function fetchIpsumDevices() {
  const res = await axios.get(ipsumDevicesRootURL(), {
    withCredentials: true
  });
  return res.data.sort((a, b) => objComparatorNumber(a, b, 'id')).map(el => {
    return { ...el, visual_name: `${el['id']} - ${el['alias']}` };
  });
}

export async function createIpsum(useAlerts, payload) {
  await remoteCreate(useAlerts, ipsumDevicesRootURL(), payload, 'Ipsum Device', 'IPSUMDevice');
}

export async function modifyPutIpsum(useAlerts, payload, ipsumId) {
  await remoteModifyPut(useAlerts, `${ipsumDevicesRootURL()}${ipsumId}/`, payload, 'Ipsum Device', 'IPSUMDevice');
}

export async function fetchIpsumLastPower(ipsumId) {
  const res = await axios.get(`${ipsumDevicesRootURL()}${ipsumId}/lastpower/`, {
    withCredentials: true
  });
  return res.data;
}

export async function fetchIpsumLastPowerDefault(ipsumId) {
  try {
    return await fetchIpsumLastPower(ipsumId);
  } catch (e) {
    if (e.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      if (e.response.status === 404) {
        return {};
      } else {
        throw e;
      }
    } else if (e.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser
      throw e;
    } else {
      // Something happened in setting up the request that triggered an Error
      throw e;
    }
  }
}
